const getCustomProp = (entry, key) => {
  if (entry?.customProps) {
    try {
      const props = JSON.parse(entry.customProps);
      if (props && typeof props === 'object' && !Array.isArray(props)) {
        return props[key];
      }
      return undefined;
    } catch {
      return undefined;
    }
  }
  return undefined;
};

// This function takes in mediaSlotData and an optional mediaCollectionIndex (defaulting to 0) and normalizes the
// data structure to match what the SponsoredUniversalBanner component expects.
export const normalizeMediaSlotData = ({ mediaSlotData, mediaCollectionIndex = 0 }) => {
  if (mediaSlotData?.slot) {
    const { slot } = mediaSlotData;
    const mediaCollection = slot.mediaCollections?.[mediaCollectionIndex];
    const media = mediaCollection?.media?.[0];
    if (!media) return { data: null, loading: false, error: null };

    // For sponsored banners, we want to check if the useSpecialBanner custom prop is set to true (boolean or string) within media
    // and include that in the normalized data.
    const rawUseSpecialBanner = getCustomProp(media, 'useSpecialBanner');
    const useSpecialBanner = rawUseSpecialBanner === true || rawUseSpecialBanner === 'true';

    // The normalized data structure is designed to match what the SponsoredUniversalBanner component expects.
    // The data being passed is from the new media collection structure within MarTech
    return {
      data: {
        sponsored: {
          banner: {
            bannerURL: media.sourceDesktop?.[0]?.uri || '',
            bannerURLMobile: media.sourceMobile?.[0]?.uri || '',
            clickthruURL: media.sourceDesktop?.[0]?.hyperlink || media.sourceMobile?.[0]?.hyperlink || '',
            altText: media.sourceDesktop?.[0]?.altText || media.sourceMobile?.[0]?.altText || '',
            useSpecialBanner,
          }
        },
      },
      loading: false,
      error: null,
    };
  }
  return { data: null, loading: false, error: null };
};

export default normalizeMediaSlotData;
